import {CustomerEmail, Validators} from "@raskrask-dk/raskrask-utils";
import {Action} from "../../../action/action";
import type NotAvailableState from "../notavailableState";

export const SET_SIGN_UP_EMAIL = "SET_SIGN_UP_EMAIL";
export class SetSignUpEmail extends Action<typeof SET_SIGN_UP_EMAIL, CustomerEmail> {
  readonly type = SET_SIGN_UP_EMAIL;
  protected state: NotAvailableState;

  constructor(state: NotAvailableState, data?: CustomerEmail) {
    super(state, data);
    this.state = state;
  }

  public isDoable(): boolean {
    return true;
  }
  public isValid(): boolean {
    const email = this.data;
    const isEmailValid = Validators.emailValidator(email);
    return this.isDoable() && isEmailValid;
  }
}
